/** Shared across tabs so vendor autologin in a new tab can skip logout API during T&C. */
export const PARTIAL_AUTH_KEY = 'partialAuth';

export function isPartialAuthActive(): boolean {
  return localStorage.getItem(PARTIAL_AUTH_KEY) === 'true';
}

export function setPartialAuthActive(active: boolean): void {
  if (active) {
    localStorage.setItem(PARTIAL_AUTH_KEY, 'true');
  } else {
    localStorage.removeItem(PARTIAL_AUTH_KEY);
  }
}

export function clearPartialAuth(): void {
  setPartialAuthActive(false);
}
